import { Switch } from "antd";
import React, { useState } from 'react';
import { SpotService } from "../../../util/services/spot";
import { showErrorResponse } from "../../../util/varibles/global";
import { IVessel } from "../../../util/varibles/interface";

interface IProps {
    vessel: IVessel
    onSave?(value: boolean): void
}

const ChangeSpot: React.FC<IProps> = ({ vessel, onSave }) => {
    const [loading, setLoading] = useState(false);

    const changeSpot = (enable_spot: boolean) => {
        const { id: vessel_id, enable_auto } = vessel;
        if (loading)
            return;
        setLoading(true);
        SpotService.changeSpecialMode({ vessel_id, enable_spot, enable_auto })
            .then(() => {
                onSave?.(enable_spot);
                setLoading(false);
            })
            .catch(error => {
                showErrorResponse('Update failed', error)
                setLoading(false);
            })
    }

    return <Switch
        checkedChildren="On"
        unCheckedChildren="Off"
        checked={!!vessel.enable_spot}
        loading={loading}
        onClick={(e) => changeSpot(e)}
    />
};

export default ChangeSpot;
